(function () {
  function initUgcGallery() {
    document.querySelectorAll('.js-swiper-ugc-gallery').forEach(function (el) {
      if (el.swiper) return;

      var speed = parseInt(el.getAttribute('data-autoplay-speed'), 10) || 4000;
      var slideCount = el.querySelectorAll('.swiper-slide').length;

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: slideCount > 4,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.6,
        },
        grabCursor: true,
        speed: 4000,
        autoplay: slideCount > 1
          ? {
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        breakpoints: {
          0: { spaceBetween: 12 },
          750: { spaceBetween: 16 },
          1100: { spaceBetween: 20 },
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUgcGallery);
  } else {
    initUgcGallery();
  }

  document.addEventListener('shopify:section:load', initUgcGallery);
})();
